import { render, staticRenderFns } from "./BidsOsagoPage.vue?vue&type=template&id=22d30f85"
import script from "./BidsOsagoPage.vue?vue&type=script&lang=js"
export * from "./BidsOsagoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports